export const includesBvLabel = (value) => {
  if (!value) return false;
  if (typeof value === "string") {
    return value.includes(" BV ");
  }
  if (Array.isArray(value)) {
    return value.some((item) => typeof item === "string" && item.includes(" BV "));
  }
  if (typeof value === "object" && value?.name) {
    return value.name.includes(" BV ");
  }
  return false;
};
